<p>Il y a déjà {{ this.dataIn.winmedia.length }} version(s) correspondant à ce titre</p>

<ul *ngFor="let winres of this.dataIn.winmedia">
  <li>Version : «{{ winres.version }}» | Format : «{{ winres.format }} ({{ winres.bitrate }})»</li>
</ul>

<p>Voulez-vous quand même importer ce nouveau fichier ? La version doit-être différente de celles listées ci-dessus</p>

<div mat-dialog-actions>
  <button mat-button (click)="closeDialog(false)">Non (annuler cet import)</button>
  <button mat-button (click)="closeDialog(true)">Oui (ajouter cette nouvelle version)</button>
</div>
